import { useState, useEffect } from 'react';
import { useLazyFetchExamsQuery } from '../service';

export const useFetchExams = () => {
	const [exams, setExams] = useState(null);
	const [pagination, setPagination] = useState({
		currentPage: 1,
		pageSize: 10,
		totalCount: 0
	});
	const [lastArgs, setLastArgs] = useState(null);

	const [triggerFetchExams, { data: existingExams, isLoading, error }] = useLazyFetchExamsQuery();

	const fetchExams = (payload) => {
		triggerFetchExams(payload);
		setLastArgs(payload);
	};

	const refetchExams = () => {
		if (lastArgs) {
			triggerFetchExams(lastArgs);
		}
	};

	useEffect(() => {
		if (existingExams) {
			setExams(existingExams.Exams);
			setPagination((prev) => ({
				...prev,
				totalCount: existingExams.TotalCount,
				pageSize: 10,
				...(existingExams.Page !== undefined && { currentPage: existingExams.Page })
			}));
		}
	}, [existingExams]);

	const resetPagination = () => setPagination((prev) => ({ ...prev, currentPage: 1 }));

	return {
		exams,
		setExams,
		pagination,
		setPagination,
		resetPagination,
		fetchExams,
		refetchExams,
		isLoading,
		error
	};
};
